module.exports = __webpack_public_path__ + "img/20200514_152806.1a6bc4c7.jpg";